import { create } from 'zustand';
import type { SpeedUnit, DistanceUnit, FuelUnit } from '@boatnav/core';

/** Rettvisende (true) vs. misvisende/magnetisk (magnetic), spec 14C. */
export type CourseRef = 'true' | 'magnetic';

/**
 * App-wide display units (spec 07 ENHETER). Device-local (not synced); storage
 * everywhere else stays kn/nm/l-per-nm/true-degrees — conversion happens at
 * the format layer.
 */
export interface Units {
  speed: SpeedUnit;
  distance: DistanceUnit;
  consumption: FuelUnit;
  courseRef: CourseRef;
}

const KEY = 'los.units';
const DEFAULTS: Units = {
  speed: 'kn',
  distance: 'nm',
  consumption: 'l_per_nm',
  courseRef: 'true',
};

function load(): Units {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<Units>) };
  } catch {
    /* ignore */
  }
  return DEFAULTS;
}

interface UnitsState extends Units {
  set: (patch: Partial<Units>) => void;
}

export const useUnitsStore = create<UnitsState>((set, get) => ({
  ...load(),
  set: (patch) => {
    const next = { ...get(), ...patch };
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({
          speed: next.speed,
          distance: next.distance,
          consumption: next.consumption,
          courseRef: next.courseRef,
        }),
      );
    } catch {
      /* ignore */
    }
    set(patch);
  },
}));
